import React from 'react';

const BounceLoading = ({ style }) => (
    <div
        style={{
            position: 'relative',
            justifySelf: 'center',
            alignSelf: 'center',
            margin: 'auto',
            ...style,
        }}
    >
        <div className="double-bounce1" />
        <div className="double-bounce2" />
    </div>
);

export default BounceLoading;
